<script lang="ts">
  import { CheckCircle2 } from "@lucide/svelte";
  import type { ConfiguratorTerm } from "../../../types";
  import { __ } from '@wordpress/i18n';

  type Props = {
    terms: ConfiguratorTerm[];
    selectedColors?: string[];
    showContinueButton?: boolean;
    onselect?: (termSlug: string) => void;
    oncontinue?: () => void;
  };

  let {
    terms,
    selectedColors = $bindable([]),
    showContinueButton = true,
    onselect,
    oncontinue,
  }: Props = $props();

  // Check if any terms have images
  const hasImages = $derived(terms.some((term) => term.image));

  function handleColorSelect(termSlug: string) {
    const index = selectedColors.indexOf(termSlug);
    if (index > -1) {
      selectedColors = selectedColors.filter((slug) => slug !== termSlug);
    } else {
      selectedColors = [...selectedColors, termSlug];
    }
    onselect?.(termSlug);
  }

  function isSelected(termSlug: string): boolean {
    return selectedColors.includes(termSlug);
  }
</script>

<!-- Info message -->
<p class="wpc-multiselect-info">{__('U kunt meerdere opties selecteren.', 'wpc')}</p>

{#if hasImages}
  <!-- Image grid layout - same as AttributeSelector -->
  <div class="wpc-options-grid">
    {#each terms as term (term.id)}
      {@const selected = isSelected(term.slug)}
      <label class="wpc-option-card {selected ? 'wpc-option-card--selected' : ''}">
        <input
          type="checkbox"
          class="wpc-sr-only"
          value={term.slug}
          checked={selected}
          onchange={() => handleColorSelect(term.slug)}
        />

        {#if term.image}
          <img src={term.image} alt={term.name} loading="lazy" decoding="async" class="wpc-option-card__image" />
        {/if}

        <p class="wpc-option-card__name">{term.name}</p>

        {#if selected}
          <div class="wpc-option-card__check">
            <CheckCircle2 size={16} color="white" />
          </div>
        {/if}
      </label>
    {/each}
  </div>
{:else}
  <!-- Checkbox list layout - same as AttributeSelector radio list -->
  <div class="wpc-options-list">
    {#each terms as term (term.id)}
      {@const selected = isSelected(term.slug)}
      <label class="wpc-option-item {selected ? 'wpc-option-item--selected' : ''}">
        <input
          type="checkbox"
          class="wpc-checkbox"
          value={term.slug}
          checked={selected}
          onchange={() => handleColorSelect(term.slug)}
        />
        <span>{term.name}</span>
      </label>
    {/each}
  </div>
{/if}

<!-- Continue button -->
{#if showContinueButton && selectedColors.length > 0}
  <div class="wpc-multiselect-actions">
    <button type="button" class="button wpc-btn" onclick={oncontinue}>
      {__('Ga verder', 'wpc')}
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="wpc-btn__icon">
        <path
          fill-rule="evenodd"
          d="M3 10a.75.75 0 01.75-.75h10.638L10.23 5.29a.75.75 0 111.04-1.08l5.5 5.25a.75.75 0 010 1.08l-5.5 5.25a.75.75 0 11-1.04-1.08l4.158-3.96H3.75A.75.75 0 013 10z"
          clip-rule="evenodd"
        />
      </svg>
    </button>
  </div>
{/if}
